  <img
    src="../../../../assets/img/tc-davivienda/Kv.png"
    alt=""
    class="banner-tcDavivienda"
  />
  <div class="tc-content">
    <h1 class="title_1">{{ "¡Es momento de " | uppercase }}</h1>
    <h1 class="title_2">{{ "disfrutar de un mundo " | uppercase }}</h1>
    <h1 class="title_1">{{ "de beneficios!" | uppercase }}</h1>
    <hr />
    <p class="desc">
      <mark>Reciba servicios gratis</mark> de SERVICIOS BOLIVAR solo por usar su
      tarjeta de crédito Davivienda.
    </p>
  </div>

